import styled from 'styled-components'

export const ConnectorContainer = styled.div`
  height: 2px;
  width: 3rem;
  background: #ecece2;
`
